import { render, staticRenderFns } from "./ResidentMediaManager.vue?vue&type=template&id=3c418cfe&"
import script from "./ResidentMediaManager.vue?vue&type=script&lang=js&"
export * from "./ResidentMediaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports